/**
 * image-with-upsells-item
 *
 * A Web Component that manages per-product variant state within the
 * "Image with Upsells" section. Handles:
 *  - Updating price and compare-at price on variant change
 *  - Enabling/disabling the ATC button based on availability
 *  - Syncing the hidden `.product-variant-id` input for product-form.js
 *  - Opening/closing the per-product size guide dialog
 */
class ImageWithUpsellsItem extends HTMLElement {
  #variants = [];
  #variantSelect = null;
  #variantIdInput = null;
  #priceEls = null;
  #comparePriceEl = null;
  #submitBtn = null;
  #stockEl = null;

  connectedCallback() {
    this.#variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.#variantSelect = this.querySelector('[data-variant-select]');
    this.#variantIdInput = this.querySelector('.product-variant-id');
    this.#priceEls = this.querySelectorAll('.js-price-regular');
    this.#comparePriceEl = this.querySelector('.js-price-compare-at-price');
    this.#submitBtn = this.querySelector('[data-atc-btn]');
    this.#stockEl = this.querySelector('[data-stock-status]');

    this.#variantSelect?.addEventListener('change', () => this.#onVariantChange());

    const dialog = this.querySelector('[data-size-guide-dialog]');

    this.querySelector('[data-size-guide-trigger]')
      ?.addEventListener('click', () => dialog?.showModal());

    this.querySelector('[data-size-guide-close]')
      ?.addEventListener('click', () => dialog?.close());

    dialog?.addEventListener('click', ({ target, currentTarget }) => {
      if (target === currentTarget) currentTarget.close();
    });
  }

  #onVariantChange() {
    const variant = this.#variants.find(v => v.id === parseInt(this.#variantSelect.value, 10));
    if (!variant) return;

    const onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);

    if (this.#variantIdInput) {
      this.#variantIdInput.value = variant.id;
      this.#variantIdInput.disabled = !variant.available;
    }

    if (this.#priceEls.length > 0) {
      this.#priceEls.forEach(priceEl => {
        priceEl.textContent = window.formatMoneyFn(variant.price, window.moneyFormat);
        priceEl.classList.toggle('imu__item-price--sale', onSale);
      });
    }

    if (this.#comparePriceEl) {
      this.#comparePriceEl.textContent = onSale ? window.formatMoneyFn(variant.compare_at_price, window.moneyFormat) : '';
      this.#comparePriceEl.hidden = !onSale;
    }

    if (this.#submitBtn) {
      this.#submitBtn.disabled = !variant.available;
      const textEl = this.#submitBtn.querySelector('[data-atc-text]');
      if (textEl) {
        textEl.textContent = variant.available
          ? this.#submitBtn.dataset.addText
          : this.#submitBtn.dataset.soldOutText;
      }
    }

    this.#stockEl?.setAttribute('data-available', variant.available ? 'true' : 'false');
  }
}

customElements.define('image-with-upsells-item', ImageWithUpsellsItem);
